import React from "react";

import {
  DropdownButton,
  DropdownContainer,
  DropdownContent,
  DropdownItem,
  DropdownWrapper,
} from "./dropdownMenu.styles";

interface DropdownMenuProps {
  title: string;
  options: { label: string; path: string }[];
}

const DropdownMenu: React.FC<DropdownMenuProps> = ({ title, options }) => {
  const findBiggerOptionTitle = React.useMemo(() => {
    return options.reduce(
      (longest, current) =>
        current.label.length > longest.length ? current.label : longest,
      options[0].label
    );
  }, [options]);

  return (
    <DropdownContainer>
      <DropdownWrapper>
        <DropdownButton>{title}</DropdownButton>
        <DropdownContent sizeWidth={findBiggerOptionTitle.length}>
          {options.map((option, index) => (
            <DropdownItem key={index} to={option.path}>
              {option.label}
            </DropdownItem>
          ))}
        </DropdownContent>
      </DropdownWrapper>
    </DropdownContainer>
  );
};

export default DropdownMenu;
